import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  alt: "",
  src: "/assets/img/logo-small.svg"
}, null, -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = {
  key: 1,
  class: "test-header"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h3", { class: "flow-title" }, "Listening", -1)
const _hoisted_6 = { class: "flow-list" }
const _hoisted_7 = { class: "flow-list__item" }
const _hoisted_8 = { class: "flow-list__part" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "PART", -1)
const _hoisted_10 = { class: "number" }
const _hoisted_11 = { class: "flow-list__number" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("ruby", null, [
    /*#__PURE__*/_createTextVNode("問"),
    /*#__PURE__*/_createElementVNode("rp", null, "（"),
    /*#__PURE__*/_createElementVNode("rt", null, "もん"),
    /*#__PURE__*/_createElementVNode("rp", null, "）")
  ])
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h3", { class: "flow-title" }, "Reading", -1)
const _hoisted_14 = { class: "flow-list" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "flow-list__item" }
const _hoisted_17 = { class: "flow-list__part" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "PART", -1)
const _hoisted_19 = { class: "number" }
const _hoisted_20 = { class: "flow-list__number" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("ruby", null, [
    /*#__PURE__*/_createTextVNode("問"),
    /*#__PURE__*/_createElementVNode("rp", null, "（"),
    /*#__PURE__*/_createElementVNode("rt", null, "もん"),
    /*#__PURE__*/_createElementVNode("rp", null, "）")
  ])
], -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("ruby", null, [
    /*#__PURE__*/_createTextVNode("前"),
    /*#__PURE__*/_createElementVNode("rp", null, "（"),
    /*#__PURE__*/_createElementVNode("rt", null, "まえ"),
    /*#__PURE__*/_createElementVNode("rp", null, "）")
  ]),
  /*#__PURE__*/_createTextVNode("へ")
], -1)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("ruby", null, [
    /*#__PURE__*/_createTextVNode("次"),
    /*#__PURE__*/_createElementVNode("rp", null, "（"),
    /*#__PURE__*/_createElementVNode("rt", null, "つぎ"),
    /*#__PURE__*/_createElementVNode("rp", null, "）")
  ]),
  /*#__PURE__*/_createTextVNode("へ")
], -1)
const _hoisted_25 = [
  _hoisted_24
]

import {inject, ref, watch} from 'vue';
import { useRoute, useRouter } from 'vue-router'
import Timer from '@/components/parts/Timer.vue'
import { appKey, examKey } from "@/main";
import { Page, PartInfo, SessionData } from "@/store/exam";
import DemoControl from "@/components/parts/DemoControl.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Flow',
  emits: ['overridePageName'],
  setup(__props, { emit }) {

const app = inject(appKey);
const exam = inject(examKey);


const route = useRoute();
const router = useRouter();

const group = route.params.group;
const page = ref();
const examType = route.params.examtype;
const baseUrl = exam?.getAudioUrl();

const partsListening = ref<PartInfo[]>([]);
const partsReading = ref<PartInfo[]>([]);
const currentPart = ref<number>(0);

const timeRemaining = ref<number | null>(null);
const timeInitial = ref<number>(0);

const session = ref<SessionData>();
const isReachedLastQuestion = ref<boolean>(false);

const timeoutHandler = ref();

const init = async() => {
  page.value = parseInt(typeof route.params.page === 'string' ? route.params.page : route.params.page[0]);
  if (!exam) return;

  const questions = await exam.questions();

  if (examType == 'reading') {
    currentPart.value = questions.reading.parts.filter(x => x.partNumber == questions.reading.pages[page.value].partNumber)[0].partNumber;

    session.value = await exam.session();
    timeRemaining.value = session.value.readingTimeRemaining;
    timeInitial.value = session.value.readingTimeRemaining;
  }
  else {
    currentPart.value = questions.listening.parts.filter(x => x.partNumber == questions.listening.pages[page.value].partNumber)[0].partNumber;
  }

  partsListening.value = await exam.createPartsList(questions.listening);
  partsReading.value = await exam.createPartsList(questions.reading);
  isReachedLastQuestion.value = await exam.isReachedLastQuestion();

  if (route.name != 'flow') {
    return;
  }

  timeoutHandler.value = setTimeout(async() => {
    if (examType == 'listening') {
      app?.playAudioUrl(baseUrl + 'part' + currentPart.value + '.m4a', false, async () => {
        await next();
      });
    }
    else if (currentPart.value == partsReading.value[0].number) {
      setTimeout(() => {
        next();
      }, 3000);
    }
  }, 1000);
  emit('overridePageName', 'flow');
}
init();

const updateTimer = async(_timeRemaining: number) => {
  timeRemaining.value = _timeRemaining;
}
const timeover = async() => {
  await exam?.readingEnd();
  app?.stopAudio();
  router.replace(`/cbt/${group}/end`);
}

const jump = async(partNumber: number) => {
  if (!exam) return;
  if (examType == 'listening' || partNumber == currentPart.value || !isReachedLastQuestion.value) {
    return;
  }
  const questions = await exam.questions();
  const firstPage = questions.reading.pages.find((p: Page) => p.partNumber == partNumber);
  if (!firstPage) return;
  const firstPageNumber = questions.reading.pages.indexOf(firstPage);
  router.replace(`/cbt/${group}/reading/${firstPageNumber + 1}`); // 練習問題ではなく最初の問題にジャンプ
}

const next = async() => {
  if (examType == 'reading') {
    if (session.value) {
      session.value.readingTimeRemaining = timeRemaining.value || 0;
      await exam?.updateSession(session.value);
    }
    router.replace(`/cbt/${group}/${examType}/${page.value}`);
  }
  else {
    router.replace(`/cbt/${group}/${examType}/${page.value}/training`);
  }
}

watch(route, ()=> {
  clearTimeout(timeoutHandler.value);
  init();
});

const prev = () => {
  router.replace(`/cbt/${group}/${examType}/${page.value - 1}`);
}

const demoPrev = () => {
  if (examType === 'listening') {
    app?.stopAudio();
    if (page.value === 0) {
      router.replace(`/cbt/${group}/caution`);
    } else {
      prev();
    }
  } else {
    if (page.value === 0) {
      router.replace(`/cbt/${group}/reading-caution`);
    } else {
      prev();
    }
  }
};
const demoNext = () => {
  app?.stopAudio();
  if (examType === 'listening') {
    router.replace(`/cbt/${group}/${examType}/${page.value}/training`);
  } else {
    router.replace(`/cbt/${group}/${examType}/${page.value}`);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      (_unref(examType) !== 'reading')
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "m-logo",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(exam).isDebug() && next()))
          }, _hoisted_2))
        : _createCommentVNode("", true),
      (_unref(examType) === 'reading')
        ? (_openBlock(), _createElementBlock("header", _hoisted_3, [
            _hoisted_4,
            (timeInitial.value)
              ? (_openBlock(), _createBlock(Timer, {
                  key: 0,
                  onTimeover: timeover,
                  onUpdate: updateTimer,
                  initTimeRemaining: timeRemaining.value
                }, null, 8, ["initTimeRemaining"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (partsListening.value.length > 0)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _hoisted_5,
            _createElementVNode("ul", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(partsListening.value, (part) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: part.number,
                  class: _normalizeClass({'is-current': part.number === currentPart.value, 'is-done': part.number < currentPart.value })
                }, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("p", _hoisted_8, [
                      _hoisted_9,
                      _createElementVNode("span", _hoisted_10, _toDisplayString(part.number), 1)
                    ]),
                    _createElementVNode("p", _hoisted_11, [
                      _createTextVNode(_toDisplayString(part.questionCount), 1),
                      _hoisted_12
                    ])
                  ])
                ], 2))
              }), 128))
            ])
          ], 64))
        : _createCommentVNode("", true),
      (partsReading.value.length > 0)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
            _hoisted_13,
            _createElementVNode("ul", _hoisted_14, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(partsReading.value, (part) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: part.number,
                  class: _normalizeClass({'is-current': part.number === currentPart.value, 'is-link': isReachedLastQuestion.value}),
                  onClick: ($event: any) => (jump(part.number))
                }, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("p", _hoisted_17, [
                      _hoisted_18,
                      _createElementVNode("span", _hoisted_19, _toDisplayString(part.number), 1)
                    ]),
                    _createElementVNode("p", _hoisted_20, [
                      _createTextVNode(_toDisplayString(part.questionCount), 1),
                      _hoisted_21
                    ])
                  ])
                ], 10, _hoisted_15))
              }), 128))
            ])
          ], 64))
        : _createCommentVNode("", true),
      (_unref(examType) === 'reading' && page.value >= 1)
        ? (_openBlock(), _createElementBlock("a", {
            key: 4,
            onClick: prev,
            class: "m-control__prev"
          }, _hoisted_23))
        : _createCommentVNode("", true),
      (_unref(examType) === 'reading')
        ? (_openBlock(), _createElementBlock("a", {
            key: 5,
            onClick: next,
            class: "m-control__next",
            ref: "nextButton"
          }, _hoisted_25, 512))
        : _createCommentVNode("", true)
    ]),
    _createVNode(DemoControl, {
      onPrev: demoPrev,
      onNext: demoNext
    })
  ], 64))
}
}

})